import type { BadgeColor } from '@kula-ai/components';

// Digit grouping resolved by the backend (chart.number_format): lakh_crore →
// en-IN, thousands → en-US, else the viewer's locale.
export const formatAmount = (n: number, numberFormat?: string): string => {
  if (numberFormat === 'lakh_crore') return n.toLocaleString('en-IN');
  if (numberFormat === 'thousands') return n.toLocaleString('en-US');
  return n.toLocaleString();
};

// Card `tone` → Badge colour, grey fallback.
const TONE_COLOR: Record<string, BadgeColor> = {
  success: 'green',
  warning: 'orange',
  error: 'red',
  primary: 'primary',
  neutral: 'grey',
};

export const toneBadgeColor = (t?: string): BadgeColor =>
  TONE_COLOR[t ?? ''] ?? 'grey';

// Curated copy + colour for known backend badges; unknown ones pass through
// with no colour (the card's tone decides).
export interface BadgeMeta {
  label: string;
  color?: BadgeColor;
}

const BADGE_META: Record<string, BadgeMeta> = {
  'Your set': { label: 'In your set', color: 'green' },
  'Ceiling only': { label: 'Market ceiling', color: 'orange' },
};

export const badgeMeta = (badge: string): BadgeMeta =>
  BADGE_META[badge] ?? { label: badge };
